Shopware.Component.extend('moorl-abstract-page-create', 'moorl-abstract-page-detail');
